module.exports = __webpack_public_path__ + "img/full4-min.2bc6cd91.png";